import React, { Component, useState, useRef } from "react";
import {
  makeStyles,
  withStyles,
  useTheme,
  styled,
} from "@material-ui/core/styles";
import Save from "../../../../assets/img/svg/save.svg";
import Cancel from "../../../../assets/img/svg/cancel.svg";
import image from "../../../../assets/img/svg/Image.svg";
import {
  TextField,
  InputBase,
  InputAdornment,
  IconButton,
  Checkbox,
} from "@material-ui/core";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import Autocomplete from "react-autocomplete";
import { useNavigate } from "react-router-dom";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getPCPActivity, addPCP } from "../../../../actions/PCPAction";
import styles from "../../../../assets/jss/customStyle";
import List from "@material-ui/core/List";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import $ from "jquery";
import moment from "moment";
import Delete from "../../../../assets/img/svg/delete.svg";
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import { getlookupdocinfo } from "../../../../actions/MasterDataAction";
import del from "../../../../assets/img/svg/Del.svg";
import { getSettingsFormat } from "../../../../actions/SettingsAction";

const useStyles = makeStyles((theme) => ({
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  error: {
    color: "#f44336",
  },
  helperText: {
    "& p": {
      marginLeft: "0px !important",
    },
  },
  button: {
    background: "#FFFFFF",
    border: "none",
    boxSizing: "border-box",
    borderRadius: "7px",
  },
}));

const BootstrapError = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 0,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #f44336",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
  },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 0,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
  },
}))(InputBase);

const names = ["Oliver Hansen", "Van Henry", "April Tucker", "Ralph Hubbard"];

const CheckboxWithBlackCheck = withStyles({
  root: {
    "& .MuiSvgIcon-root": {
      fill: "#FFFFFF",
      width: 20,
      height: 20,
      border: "1px solid #000000",
      "&:hover": {
        backgroundColor: "#FFFFFF",
      },
    },
    "&$checked": {
      "& .MuiIconButton-label": {
        position: "relative",
        zIndex: 0,
        backgroundColor: "#FFFFFF",
      },
      "& .MuiIconButton-label:after": {
        content: '""',
        height: 10,
        width: 10,
        position: "absolute",
        backgroundColor: "#000000",
        zIndex: -1,
      },
    },
  },
  checked: {},
})(Checkbox);

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

class AddPCP extends Component {
  constructor(props) {
    super(props);
    this.inputFile = React.createRef();
    this.state = {
      isMobile: false,
      Docs: [],
      state: {
        checkedA: true,
        checkedB: false,
      },
      ActivityError: false,
      cancel: false,
      DateError: false,
      isError: false,
      cancel: false,
      ProjectId: 0,
      addData: {
        Id: 0,
        ProjectId: 0,
        Activity: "",
        Date: "",
        Description: "",
        Modifiedby: "",
      },
    };
  }

  setCheckbox = (str) => {
    this.state.Docs.map((i) => {
      if (str == i.fileName) {
        i.check = !i.check;
        this.setState({});
      }
    });
  };

  AttachFiles = (e) => {
    this.inputFile.current.click();
  };

  componentDidMount() {
    this.props.dispatch(getlookupdocinfo("PreCutting"));
    this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
    this.state.ProjectId = localStorage.getItem("DashId");
    this.state.addData.Modifiedby = localStorage.getItem("UserRoles");
    this.setState({});
    const { dispatch } = this.props;
    this.props.dispatch(getSettingsFormat(this.state.ProjectId));
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.interval = setInterval(() => {
      this.resize1();
    }, 10);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    window.removeEventListener("resize", this.resize.bind(this));
    $("#PRECUT1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#Precutting1 .MuiListItemText-primary").removeClass("fw-bolder");
    $("#Precutting").addClass("d-none");
    $("#Precutting").removeClass("d-block");
    $("#PCPL").removeClass("active-color");
    $("#PCPT").removeClass("fw-bolder");
  }
  sidebar = () => {
    if (this.state.cancel === true) {
      window.$("#cancelpopup1").modal("show");
    } else {
      this.props.navigate("/sidebar");
    }
  };
  SideBarCancel = () => {
    this.props.dispatch({ type: "CANCEL", data: false });
    window.$("#cancelpopup1").modal("hide");
    this.props.navigate("/sidebar");
  };
  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }
  };

  resize1 = () => {
    $("#PRECUT1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#Precutting1 .MuiListItemText-primary").addClass("fw-bolder");
    $("#Precutting").removeClass("d-none");
    $("#Precutting").addClass("d-block");
    $("#PCPL").addClass("active-color");
    $("#PCPT").addClass("fw-bolder");
  };
  AddCancel1 = () => {
    if (this.state.cancel == true) {
      window.$("#cancelpopup").modal("show");
    } else {
      this.props.dispatch({ type: "CANCEL", data: false });
      this.props.navigate(`/precuttingprogressreport`);
    }
  };
  AddCancel = () => {
    this.props.dispatch({ type: "CANCEL", data: false });
    window.$("#cancelpopup").modal("hide");
    this.props.navigate("/precuttingprogressreport");
  };
  OpenPopup = (i) => {
    this.state.delindex = i;
    this.setState({});
    window.$("#deletepopup").modal("show");
  };
  DeleteItem = (name) => {
    let tempData = [];
    this.state.Docs.map((i, ind) => {
      if (ind != this.state.delindex) {
        tempData.push(i);
      }
    });
    this.state.Docs = tempData;
    this.setState({});
    window.$("#deletepopup").modal("hide");
  };
  AddSave = () => {
    const { dispatch } = this.props;
    const { Activity, Date, Description } = this.state.addData;
    if (Activity.trim() === "") {
      this.state.ActivityError = true;
      this.state.addData.Activity = this.state.addData.Activity.trim();
      this.setState({});
    } else {
      this.state.ActivityError = false;
      this.state.addData.Activity = this.state.addData.Activity.trim();
      this.setState({});
    }
    if (Date === "") {
      this.state.DateError = true;
      this.setState({});
    } else {
      this.state.DateError = false;
      this.setState({});
    }
    if (this.state.addData.Activity !== "" && Date !== "") {
      this.props.dispatch({ type: "CANCEL", data: false });
      let formData = new FormData();
      Array.from(this.state.Docs).forEach(async (a) => {
        formData.append("photo", a.fdata);
      });
      if (this.state.addData.Description == "") {
        this.state.addData.Description = "";
        this.setState({});
      } else {
        this.state.addData.Description = this.state.addData.Description.trim();
        this.setState({});
      }
      this.setState({});
      this.addPCP(this.state.addData, formData, this.state.ProjectId);
    }
  };
  addPCP = (data, formData) => {
    let apiUrl = API.PCP_LISTVIEW;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.adduploadpcpdocinfo(formData, response.data);
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };

  adduploadpcpdocinfo = (data, id) => {
    let apiUrl = API.PCP_LISTVIEW + "/" + id;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });

        if (response?.status === 200) {
          this.props.navigate("/precuttingprogressreport");
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });

        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };

  handleProjectNameSearchChange = (e) => {
    this.state.cancel = true;
    this.props.dispatch({ type: "CANCEL", data: true });
    this.state.addData.Activity = e.target.value;
    this.setState({});
    // if (this.state.addData.Activity == 'others') {
    //     this.state.others = true;
    //     this.setState({});
    // }
    // else {
    //     this.state.others = false;
    //     this.setState({});
    // }
  };
  renderProjectNames = (state, val) => {
    return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  };
  handleProjectNameSelectChange = (e) => {
    this.state.cancel = true;
    this.props.dispatch({ type: "CANCEL", data: true });
    this.state.addData.Activity = e;
    this.setState({});
  };
  handleInputChange = (e, node) => {
    this.state.cancel = true;
    this.props.dispatch({ type: "CANCEL", data: true });
    if (node == "Description") {
      if (e.target.value.length - 1 < 500) {
        this.state.addData[node] = e.target.value;
        this.setState({});
      }
    } else {
      this.state.addData[node] = e.target.value;
      this.setState({});
    }
  };
  handleDateChange = (e, node) => {
    this.state.cancel = true;
    this.props.dispatch({ type: "CANCEL", data: true });
    this.state.addData[node] = e.target.value;
    this.setState({});
  };
  UploadFile = (e) => {
    this.state.cancel = true;
    this.props.dispatch({ type: "CANCEL", data: true });
    Array.from(e.target.files).forEach(async (a) => {
      let upload = {
        fileName: a.name,
        fileSize: a.size,
        check: false,
        fdata: a,
        base64: await this.toBase64(a),
      };
      this.state.Docs.push(upload);
      this.setState({});
    });
  };

  toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  render() {
    let { classes, menuToggle, PCPACTIVITY_LOOKUP, PCP_Add } = this.props;
    return (
      <>
        {this.state.isMobile ? (
          <>
            <div className="row w-100 mt-4">
              <div className="col-6 mt-auto">
                <List
                  className="pt-3 mt-4 pl-3"
                  style={{ backgroundColor: "#F6F6F6" }}
                >
                  <ListItem onClick={this.sidebar}>
                    <ListItemText
                      id={"PRECUT" + "1"}
                      className="  textNaviIcon"
                      primary="Daily Tasks"
                    />
                    <NavigateNextIcon
                      id="PRECUT"
                      className="naviIcon ml-1"
                      style={{ width: 23, height: 23 }}
                    />
                    <Divider className="border-bottom" />
                  </ListItem>
                </List>
              </div>
              <div className="col-6 pt-2 mt-5 ">
                <h4>Add New Pre Cutting Activitiy</h4>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
        <div
          className="ml-auto scroll-hide"
          style={{
            backgroundColor: "#FFFFFF",
            width: this.state.isMobile
              ? "100%"
              : menuToggle
              ? "calc(100% - 240px)"
              : "calc(100% - 64px)",
            marginTop: this.state.isMobile ? "" : -95,
          }}
        >
          {this.state.isMobile ? (
            <table className="dataTable border-top" width="100%">
              <tbody>
                <tr>
                  <td className="border-right text-center">
                    <i
                      className="fa fa-arrow-left cursorPointer"
                      onClick={this.AddCancel1}
                    ></i>
                  </td>
                  <td className="border-right text-center">
                    <button className={classes.button} onClick={this.AddSave}>
                      <img src={Save} style={{ marginTop: "-4px" }}></img>
                      &nbsp;Save
                    </button>
                  </td>
                  <td className="text-center">
                    <button
                      className={classes.button}
                      onClick={this.AddCancel1}
                    >
                      <img src={Cancel} style={{ marginTop: "-4px" }}></img>
                      &nbsp;Cancel
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          ) : (
            <table className="dataTable" width="100%">
              <tbody>
                <tr>
                  <td width="5%" className="border-right text-center">
                    <i
                      className="fa fa-arrow-left cursorPointer"
                      onClick={this.AddCancel1}
                    ></i>
                  </td>
                  <td width="95%">
                    <button className={classes.button} onClick={this.AddSave}>
                      <img src={Save} style={{ marginTop: "-4px" }}></img>
                      &nbsp;Save
                    </button>
                    <button
                      className={`${classes.button} pl-3`}
                      onClick={this.AddCancel1}
                    >
                      <img src={Cancel} style={{ marginTop: "-4px" }}></img>
                      &nbsp;Cancel
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          )}
          <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
            {this.state.isMobile ? (
              ""
            ) : (
              <h6 className="col-12 mx-2 pt-2 ml-1">
                Add New Pre-Cutting Activity
              </h6>
            )}
            <div
              className={
                this.state.isMobile
                  ? "row mt-1 mx-0 pr-2 pt-1"
                  : "row mt-1 mx-3 pr-2 pt-1"
              }
            >
              <div
                className={`row mt-2 mx-1 align-items-center ${
                  this.state.isMobile ? "" : "text-row"
                }`}
              >
                <div
                  className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${
                    this.state.isMobile
                      ? "border-left border-right border-top col-md-12"
                      : "col-md-2 px-0"
                  }`}
                >
                  <label
                    className={
                      this.state.isMobile
                        ? "d-flex mt-2"
                        : "float-end d-flex text-right m-0"
                    }
                  >
                    Date&nbsp;:
                    <div className={`${classes.helperText}`}>
                      <div className="MuiFormHelperText-contained">*</div>
                    </div>
                  </label>
                </div>
                <div
                  className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${
                    this.state.isMobile
                      ? "border-left border-right border-bottom col-md-12 pt-1 pb-3"
                      : "col-md-4 pt-4 pb-4 "
                  }`}
                >
                  {this.state.DateError ? (
                    <TextField
                      type="date"
                      variant="outlined"
                      size="small"
                      fullWidth
                      error
                      id="type-date"
                      value={
                        this.state.addData.Date &&
                        moment(this.state.addData.Date).format("yyyy-MM-DD")
                      }
                      placeholder={
                        this.state.addData.Date &&
                        moment(this.state.addData.Date).format(
                          this.props.settings.Convention
                            ? this.props.settings.Convention
                            : "DD/MM/YYYY"
                        )
                      }
                      onChange={(e) => {
                        this.handleDateChange(e, "Date");
                      }}
                      InputProps={{
                        className: `border-radius ${classes.inputfieldAlign}`,
                      }}
                      inputProps={{
                        max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                        min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                      }}
                    />
                  ) : (
                    <TextField
                      type="date"
                      variant="outlined"
                      size="small"
                      fullWidth
                      id="type-date"
                      value={
                        this.state.addData.Date &&
                        moment(this.state.addData.Date).format("yyyy-MM-DD")
                      }
                      placeholder={
                        this.state.addData.Date &&
                        moment(this.state.addData.Date).format(
                          this.props.settings.Convention
                            ? this.props.settings.Convention
                            : "DD/MM/YYYY"
                        )
                      }
                      onChange={(e) => {
                        this.handleDateChange(e, "Date");
                      }}
                      InputProps={{
                        className: `border-radius ${classes.inputfieldAlign}`,
                      }}
                      inputProps={{
                        max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                        min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                      }}
                    />
                  )}
                </div>
                <div
                  className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${
                    this.state.isMobile
                      ? "border-left border-right"
                      : "mt-2 col-md-2 px-0"
                  }`}
                >
                  <label
                    className={
                      this.state.isMobile
                        ? "d-flex mt-2"
                        : "float-end text-right m-0 d-flex"
                    }
                  >
                    Activities&nbsp;:
                    <div className={`${classes.helperText}`}>
                      <div className="MuiFormHelperText-contained">*</div>
                    </div>
                  </label>
                </div>
                <div
                  className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${
                    this.state.isMobile
                      ? "border-left border-right border-bottom col-md-12 pt-1 pb-3"
                      : "col-md-4 pt-4 pb-4 "
                  }`}
                >
                  {this.state.ActivityError ? (
                    <div className=" autocomplete-wrappers">
                      <Autocomplete
                        contentEditable={true}
                        value={this.state.addData.Activity}
                        inputProps={{
                          placeholder: "Activity",
                        }}
                        items={PCPACTIVITY_LOOKUP ?? []}
                        getItemValue={(item) => item.Name}
                        shouldItemRender={this.renderProjectNames.bind(this)}
                        renderMenu={(item) => (
                          <div className="dropdowns d-block">{item}</div>
                        )}
                        renderInput={(props) => {
                          return (
                            <input
                              className="form-control border-radius"
                              id="exampleFormControlInput1"
                              {...props}
                              fullWidth
                              style={{
                                width: "100%",
                                height: 35,
                                fontSize: 12,
                                color: "#000000",
                                borderColor: "red",
                              }}
                            />
                          );
                        }}
                        renderItem={(item, isHighlighted) => (
                          <div
                            className={`items 
                         ${isHighlighted ? "selected-items" : ""}`}
                          >
                            {item.Name}
                          </div>
                        )}
                        onChange={(e) => this.handleProjectNameSearchChange(e)}
                        onSelect={(e) => this.handleProjectNameSelectChange(e)}
                      />
                    </div>
                  ) : (
                    <div className="autocomplete-wrappers">
                      <Autocomplete
                        contentEditable={true}
                        value={this.state.addData.Activity}
                        inputProps={{
                          placeholder: "Activity",
                        }}
                        items={PCPACTIVITY_LOOKUP ?? []}
                        getItemValue={(item) => item.Name}
                        shouldItemRender={this.renderProjectNames.bind(this)}
                        renderMenu={(item) => (
                          <div className="dropdowns d-block" key={item}>
                            {item}
                          </div>
                        )}
                        renderInput={(props) => {
                          return (
                            <input
                              className="form-control border-radius"
                              id="exampleFormControlInput1"
                              {...props}
                              style={{
                                width: "100%",
                                height: 35,
                                fontSize: 12,
                                color: "#000000",
                              }}
                            />
                          );
                        }}
                        renderItem={(item, isHighlighted) => (
                          <div
                            className={`items 
                         ${isHighlighted ? "selected-items" : ""}`}
                          >
                            {item.Name}
                          </div>
                        )}
                        onChange={(e) => this.handleProjectNameSearchChange(e)}
                        onSelect={(e) => this.handleProjectNameSelectChange(e)}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div
                className={`row mx-1 align-items-center ${
                  this.state.isMobile
                    ? ""
                    : "border-left border-right border-bottom"
                }`}
              >
                <div
                  className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${
                    this.state.isMobile
                      ? "border-left border-right"
                      : "mt-n3 col-md-2"
                  }`}
                >
                  <label
                    className={
                      this.state.isMobile ? "mt-2" : "float-end text-right"
                    }
                  >
                    Description&nbsp;:
                  </label>
                </div>
                <div
                  className={`col-12 col-sm-12  col-lg-10 col-xl-11   ${
                    this.state.isMobile
                      ? "border-left border-right border-bottom col-md-12 pt-1"
                      : "col-md-10 pt-4"
                  }`}
                >
                  <TextField
                    multiline
                    rows={4}
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={this.state.addData.Description}
                    onChange={(e) => {
                      this.handleInputChange(e, "Description");
                    }}
                    InputProps={{
                      className: `border-radius ${classes.inputfieldAlign}`,
                    }}
                  />
                  <label className="float-end pt-2" style={{ opacity: "0.5" }}>
                    {this.state.addData?.Description?.length == undefined
                      ? 500 - 0
                      : 500 - this.state.addData?.Description?.length}
                    /500 Characters left
                  </label>
                </div>
              </div>
              <div
                className={`row mx-1 ${
                  this.state.isMobile
                    ? ""
                    : "border-left border-right border-bottom"
                }`}
              >
                <div
                  className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${
                    this.state.isMobile
                      ? "border-left border-right"
                      : "mt-4 col-md-2"
                  }`}
                >
                  <label
                    className={
                      this.state.isMobile
                        ? "mt-2"
                        : "mt-2 float-end text-right m-0"
                    }
                  >
                    Photos&nbsp;:
                  </label>
                </div>
                <div
                  className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${
                    this.state.isMobile
                      ? "border-left border-right  col-md-12 pt-1 pb-3"
                      : "col-md-4 pt-4 pb-4 "
                  }`}
                >
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    disabled
                    onChange={(e) => this.UploadFile(e)}
                    accept=".png,.jpg"
                    placeholder="Browse File"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment className="mr-0">
                          <IconButton
                            className="rotate p-0"
                            onClick={this.AttachFiles}
                          >
                            <AttachFileIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                      className: `border-radius ${classes.inputfieldAlign}`,
                    }}
                  />
                  <input
                    type="file"
                    hidden
                    multiple="multiple"
                    accept=".png,.jpg"
                    onChange={(e) => this.UploadFile(e)}
                    ref={this.inputFile}
                  />
                </div>
                <div className="col-12 col-sm-12 col-lg-6 col-xl-8"></div>
                <div className="row mx-0">
                  <div
                    className={`col-12 col-sm-12  col-md-12 col-lg-12 col-xl-12 align-items-center ${
                      this.state.isMobile
                        ? "border-left border-right border-bottom col-md-12"
                        : "mt-2"
                    }`}
                  >
                    <div
                      className={
                        this.state.isMobile ? "row pl-2 pr-3" : "row px-1"
                      }
                    >
                      {this.state.Docs &&
                        this.state.Docs.map((i, ind) => {
                          return (
                            <div
                              className={`col-12 col-sm-6 col-lg-6 col-xl-4 col-md-6 align-items-center px-1 mt-2 mb-2 ${
                                window.innerWidth < 410
                                  ? "col-12"
                                  : this.state.isMobile
                                  ? "col-md-4"
                                  : "col-md-6"
                              }`}
                            >
                              <div className="row d-flex">
                                <div className="col-9 col-sm-9 col-lg-9 col-xl-9 col-md-9"></div>
                                <div className="col-3 col-sm-3 col-lg-3 col-xl-3 col-md-3 pl-1 pr-2 mt-2 pt-2">
                                  <img
                                    src={Delete}
                                    className="cursorPointer"
                                    onClick={() => {
                                      this.OpenPopup(ind);
                                    }}
                                  />
                                </div>
                                <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-3 mt-3">
                                  <img
                                    src={i.base64}
                                    width= {window.innerWidth <290 ? "100%" : "257px"}
                                    style={{
                                     height: "201px",
                                      marginTop: "-9px",
                                      objectPosition: "50% 50%",
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal fade p-5 mt-5"
            id="cancelpopup"
            tabindex="-1"
            role="dialog"
            aria-labelledby="cancelpopupLabel"
            aria-hidden="true"
            style={{
              top: "13%",
              left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
            }}
          >
            <div className="modal-dialog" role="document">
              <div
                className={
                  this.state.isMobile ? "modal-content" : "modal-content p-3"
                }
              >
                <div className="modal-body pb-0">
                  <h1 className="text-center">
                    <img src={del}></img>
                  </h1>
                  <div className="text-center">
                    <h5 className="fw-bold">
                      The data will be lost. Do you really want to cancel?
                    </h5>{" "}
                  </div>
                </div>
                <div className="modal-footer border-top-0 m-auto">
                  <button
                    type="button"
                    className={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    data-dismiss="modal"
                    style={{ backgroundColor: "#00838F", border: "none" }}
                    onClick={this.AddCancel}
                  >
                    <span className="">Yes</span>
                  </button>
                  <button
                    type="button"
                    id="closemodal1"
                    className={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    onClick={() => window.$("#cancelpopup").modal("hide")}
                    style={{
                      backgroundColor: "#EBEBEB",
                      border: "none",
                      color: "#111010",
                    }}
                  >
                    <span className="">No</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal fade p-5 mt-5"
            id="deletepopup"
            tabindex="-1"
            role="dialog"
            aria-labelledby="deletepopupLabel"
            aria-hidden="true"
            style={{
              top: "13%",
              left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
            }}
          >
            <div className="modal-dialog" role="document">
              <div
                className={
                  this.state.isMobile ? "modal-content" : "modal-content p-3"
                }
              >
                <div className="modal-body pb-0">
                  <h1 className="text-center">
                    <img src={del}></img>
                  </h1>
                  <div className="text-center">
                    <h5 className="fw-bold">
                      Are you sure you want to delete?
                    </h5>{" "}
                  </div>
                </div>
                <div className="modal-footer border-top-0 m-auto">
                  <button
                    type="button"
                    data-dismiss="modal"
                    className={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    style={{ backgroundColor: "#00838F", border: "none" }}
                    onClick={() => this.DeleteItem()}
                  >
                    <span className="">Delete</span>
                  </button>
                  <button
                    type="button"
                    id="closemodal"
                    className={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    onClick={() => window.$("#deletepopup").modal("hide")}
                    style={{
                      backgroundColor: "#EBEBEB",
                      border: "none",
                      color: "#111010",
                    }}
                  >
                    <span className="">Cancel</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="modal fade p-5 mt-5"
            id="cancelpopup1"
            tabindex="-1"
            role="dialog"
            aria-labelledby="cancelpopupLabel"
            aria-hidden="true"
            style={{
              top: "13%",
              left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
            }}
          >
            <div class="modal-dialog" role="document">
              <div
                class={
                  this.state.isMobile ? "modal-content" : "modal-content p-3"
                }
              >
                <div class="modal-body pb-0">
                  <h1 className="text-center">
                    <img src={del}></img>
                  </h1>
                  <div className="text-center">
                    <h5 class="fw-bold">
                      The data will be lost. Do you really want to cancel?
                    </h5>{" "}
                  </div>
                </div>
                <div class="modal-footer border-top-0 m-auto">
                  <button
                    type="button"
                    class={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    data-dismiss="modal"
                    style={{ backgroundColor: "#00838F", border: "none" }}
                    onClick={this.SideBarCancel}
                  >
                    <span className="">Yes</span>
                  </button>
                  <button
                    type="button"
                    id="closemodal1"
                    class={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    onClick={() => window.$("#cancelpopup1").modal("hide")}
                    style={{
                      backgroundColor: "#EBEBEB",
                      border: "none",
                      color: "#111010",
                    }}
                  >
                    <span className="">No</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
    PCP_Add: state.PCPReducer.PCP_Add || [],
    PCPACTIVITY_LOOKUP: state.MasterDataReducer.Lookup_data || [],
    settings: state.commonReducer.settings || [],
  };
}

AddPCP.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddPCP))
);
